var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("button",null,{"dataModalId":_vm.id}),_c('div',{staticClass:"modal",attrs:{"id":_vm.id}},[_c('div',{staticClass:"modal__content"},[_vm._t("body")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }